// extracted by mini-css-extract-plugin
export default {"planList":"hotelFooter_planList__vL9py","itemList":"hotelFooter_itemList__JNBcD","goTop":"hotelFooter_goTop__xZDLu","hotelName":"hotelFooter_hotelName__g86zd"};